import { Avatar } from '@/components/ui/Avatar/Avatar';
import {
  AddIcon,
  BookmarkIcon,
  HomeIcon,
  MenuIcon,
  ProfileIcon
} from '@/components/ui/Icons/Icons';
import { ROUTES } from '@/constants/common';
import { SELECT_AD_TYPE_CY } from '@/constants/test-id';

const { HOME, PROFILE, BOOKMARKS } = ROUTES;

export const TABS = [
  { id: 0, icon: <HomeIcon />, route: HOME },
  { id: 1, icon: <BookmarkIcon />, route: BOOKMARKS },
  {
    id: 2,
    icon: <AddIcon />,
    route: HOME,
    'data-cy': SELECT_AD_TYPE_CY.OPEN_MODAL_BTN
  },
  {
    id: 3,
    icon: <ProfileIcon />,
    route: PROFILE,
    renderContent: (name: string, image: string) =>
      name ? <Avatar name={name} size={30} image={image} /> : <ProfileIcon />
  },
  { id: 4, icon: <MenuIcon />, route: HOME }
];
